const LiveHosts = ({ results }) => {
  return (
    <div>
      {results && results.length > 0 && (
        <div className="overflow-x-auto">
          <div className="w-full border min-w-[1100px] border-neutral300 rounded-lg text-sm">
            <div className="flex justify-between text-left px-3 xl:px-6 py-2 bg-neutral3 rounded-t-lg border-b text-neutral700 font-medium w-full">
              <span className="w-[20%]">IP Address</span>
              <span className="w-[15%]">Status</span>
              <span className="w-[15%]">FQDN</span>
              <span className="w-[15%]">Hostname</span>
              <span className="w-[15%]">Open Ports</span>
              <span className="w-[15%]">Response Time</span>
              <span className="w-[10%]">Scan Method</span>
            </div>

            {results?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`min-h-[60px] py-2 px-3 xl:px-6 flex text-neutral900 items-center ${
                    index === 0 ? "border-t-0" : "border-t border-t-[#EAECF0]"
                  } hover:bg-[#F9FAFB]`}
                >
                  <div className="w-[20%] text-left font-medium">{item.ip}</div>
                  <div className="w-[15%] text-left">
                    {item.alive ? (
                      <p className="bg-success10 text-success100 border-[1.5px] rounded-full border-[#00C8511A] w-fit px-2 py-1">
                        Alive
                      </p>
                    ) : (
                      <p className="bg-[#FF44441A] text-[#E12A5B] border-[1.5px] rounded-full border-[#FFC1C1] w-fit px-2 py-1">
                        Dead
                      </p>
                    )}
                  </div>
                  <div className="w-[15%] text-left">{item.fqdn || "-"}</div>
                  <div className="w-[15%] text-left">
                    {item.hostname || "-"}
                  </div>
                  <div className="w-[15%] text-left">
                    {item.open_ports && item.open_ports.length > 0
                      ? item.open_ports.join(", ")
                      : "-"}
                  </div>
                  <div className="w-[15%]">
                    {item.response_time ? `${item.response_time}ms` : "-"}
                  </div>
                  <div className="w-[10%] text-left">
                    {item.scan_method || "-"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {results && results.length === 0 && (
        <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
          <p className=" font-semibold text-xl">There are no results</p>
        </div>
      )}
    </div>
  );
};

export default LiveHosts;
